import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeDataInicialReceitaDiaria: ['dataInicial'],
    removeDataFinalReceitaDiaria: ['dataFinal'],
    removeAdministracaoReceitaDiaria: ['administracao'],
    removeRecursoReceitaDiaria: ['recurso'],
    removeDestinacaoReceitaDiaria: ['destinacao'],
    removeGrauReceitaDiaria: ['grau'],
    removeCodigoReceitaReceitaDiaria: ['codigoReceita'],
    setMostraAplicarFiltroReceitaDiaria: [],
    limpaFiltroReceitaDiaria: [],
    aplicarFiltroReceitaDiaria: ['filtro'],
})

const INITIAL_STATE = {
    dataInicial: '',
    dataFinal: '',
    administracao: [],
    recurso: [],
    destinacao: [],
    grau: '',
    codigoReceita: '',
    mostraAplicarFiltro: false,
}

const removeDataInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataInicial: '', mostraAplicarFiltro: true }
}
const removeDataFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataFinal: '', mostraAplicarFiltro: true }
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeRecurso = (state = INITIAL_STATE, action) => {
    state.recurso.splice(state.recurso.indexOf(action.recurso), 1)
    state.recurso = Array.from(state.recurso)
    return { ...state, mostraAplicarFiltro: true }
}
const removeDestinacao = (state = INITIAL_STATE, action) => {
    state.destinacao.splice(state.destinacao.indexOf(action.destinacao), 1)
    state.destinacao = Array.from(state.destinacao)
    return { ...state, mostraAplicarFiltro: true }
}
const removeGrau = (state = INITIAL_STATE, action) => {
    return { ...state, grau: '', mostraAplicarFiltro: true }
}
const removeCodigoReceita = (state = INITIAL_STATE, action) => {
    return { ...state, codigoReceita: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_DATA_INICIAL_RECEITA_DIARIA]: removeDataInicial,
    [Types.REMOVE_DATA_FINAL_RECEITA_DIARIA]: removeDataFinal,
    [Types.REMOVE_ADMINISTRACAO_RECEITA_DIARIA]: removeAdministracao,
    [Types.REMOVE_RECURSO_RECEITA_DIARIA]: removeRecurso,
    [Types.REMOVE_DESTINACAO_RECEITA_DIARIA]: removeDestinacao,
    [Types.REMOVE_GRAU_RECEITA_DIARIA]: removeGrau,
    [Types.REMOVE_CODIGO_RECEITA_RECEITA_DIARIA]: removeCodigoReceita,
    [Types.SET_MOSTRA_APLICAR_FILTRO_RECEITA_DIARIA]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_RECEITA_DIARIA]: limpaFiltro,
    [Types.APLICAR_FILTRO_RECEITA_DIARIA]: aplicarFiltro,
})
